// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
)

export function register(config) {
  // Check if running inside an iframe
  // Service workers will be registered from the embedding script instead
  if (window.self !== window.top) {
    console.log(
      'Service worker registration skipped: Running inside an iframe. ' +
        'Service worker will be registered from the embedding script.'
    )
    return
  }

  if ('serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href)
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      console.log('Different Origin')
      return
    }

    window.addEventListener('load', () => {
      const swUrl = isLocalhost
        ? window.location.protocol +
          '//' +
          window.location.host +
          '/serviceworker.js'
        : localStorage.getItem('url_prefix') === 'f10boxing'
        ? `${window.location.protocol}//${localStorage.getItem('url_prefix')}.${
            process.env.NODE_ENV === 'staging' ? 'stage' : 'dev'
          }.onbookee.com/serviceworker.js`
        : `${window.location.protocol}//${localStorage.getItem(
            'url_prefix'
          )}.onbookee.com/serviceworker.js`

      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config)

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then(() => {
          console.log(
            'This web app is being served cache-first by a service ' +
              'worker. To learn more, visit https://bit.ly/CRA-PWA'
          )
        })
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config)
        //   var refreshing;
        //   // When the user asks to refresh the UI, we'll need to reload the window
        //   navigator.serviceWorker.addEventListener('controllerchange', function (event) {
        //     if (refreshing) return; // prevent infinite refresh loop when you use "Update on Reload"
        //     refreshing = true;
        //     console.log('Controller loaded');
        //     window.location.reload();
        //   });
      }
    })
  }
}

function registerValidSW(swUrl, config) {
  try {
    navigator.serviceWorker
      .register(swUrl)
      .then(registration => {
        // Validate registration object
        if (!registration) {
          console.warn(
            'Service worker registration failed: registration is null'
          )
          return
        }

        // if service worker already in waiting state, show snackbar
        if (
          registration.waiting &&
          registration.waiting.state === 'installed'
        ) {
          let updateModal = document.getElementById('updateModal')
          if (updateModal) {
            updateModal.style.display = 'flex'
          }
          window.location.reload()
        }

        registration.onupdatefound = () => {
          const installingWorker = registration.installing
          if (installingWorker == null) {
            return
          }
          installingWorker.onstatechange = () => {
            // Add null check for installingWorker state
            if (!installingWorker || !installingWorker.state) {
              return
            }

            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // At this point, the updated precached content has been fetched,
                // but the previous service worker will still serve the older
                // content until all client tabs are closed.
                console.log(
                  'New content is available and will be used when all ' +
                    'tabs for this page are closed. See https://bit.ly/CRA-PWA.'
                )
                // Execute callback
                if (config && config.onUpdate) {
                  config.onUpdate(registration)
                }
              } else {
                // At this point, everything has been precached.
                // It's the perfect time to display a
                // "Content is cached for offline use." message.
                console.log('Content is cached for offline use.')

                // Execute callback
                if (config && config.onSuccess) {
                  config.onSuccess(registration)
                }
              }
            }
          }
        }

        // Add error handling for controllerchange event
        try {
          navigator.serviceWorker.addEventListener('controllerchange', () => {
            console.log('SW CONTROLLER CHANGE')
            // Show the popup with null check
            let updateModal = document.getElementById('updateModal')
            if (updateModal) {
              updateModal.style.display = 'flex'
            }
            window.location.reload()
          })
        } catch (error) {
          console.log('Error adding controllerchange listener:', error)
        }
      })
      .catch(error => {
        console.error('Error during service worker registration:', error)
      })
  } catch (err) {
    console.log('Service worker registration exception:', err)
  }
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' }
  })
    .then(response => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type')
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload()
          })
        })
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config)
      }
    })
    .catch(() => {
      console.log(
        'No internet connection found. App is running in offline mode.'
      )
    })
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister()
      })
      .catch(error => {
        console.error(error.message)
      })
  }
}
